import rivets from 'rivets';
import $ from 'jquery';
import 'jquery-placeholder';
import BaseView from '../../core/baseView';
import * as config from '../../../home24/core/config';

export default BaseView.extend({
  events: {
    'keyup .search-field-input': 'onKeyUp',
    'click .suggest-result': 'onSuggestClick',
    'touchend .suggest-result': 'onSuggestClick',
    'change .search-field-input': 'onInputChange',
    'submit form': 'onFormSubmit'
  },

  $suggestContainer: null,

  keyCode: {
    up: config.getInt('keyCodes.up'),
    down: config.getInt('keyCodes.down')
  },

  initialize: function() {
    this.binding = rivets.bind(this.el, {
      results: this.model,
      eventHandlers: this
    });

    this.$el.find('.search-field-input').placeholder();

    this.$suggestContainer = this.$el.find('.suggest');

    this.$suggestContainer.width(this.$el.width() - 2);

    $(document).on(
      'click.hideSuggest touchend.hideSuggest',
      $.proxy(this.onClickOutsideContainer, this.model)
    );
  },

  onFormSubmit: function() {
    if (!this.model.isFormSubmitable()) {
      return false;
    }

    this.model.setFormAsSubmitted();

    if (this.model.isSuggestionSelectedByKeyboard()) {
      this.model.setCurrentSearchPhrase();
    }

    return true;
  },

  /**
   * Method removes all suggestions to hide suggestion box
   * Because it is binded on document level has to be called via proxy with content pointing to this.model
   */
  onClickOutsideContainer: function(event) {
    // Clear suggestions only when click came from outside of form button
    if (!$(event.target).hasClass('search-field-submit')) {
      this.set({
        suggestions: []
      });
    }
  },

  resizeSuggestContainer: function() {
    var windowHeight = $(window).height();
    var bodyScrollTop = $(document).scrollTop();
    var windowLowerEdge = bodyScrollTop + windowHeight;
    var height =
      windowLowerEdge - (this.$el.offset().top + this.$el.height() + 30);

    if (height < 150) {
      height = 150;
    }

    this.$suggestContainer.css('max-height', height + 'px');
  },

  onInputChange: function(event) {
    this.model.setSearchPhrase(event.currentTarget.value);
  },

  /**
   * @param {Event} event
   */
  onKeyUp: function(event) {
    this.model.setSearchPhrase(event.currentTarget.value);

    var keyCode = event.keyCode;
    var doSelection = false;

    if (keyCode === this.keyCode.up) {
      this.model.moveIndexUp();
      doSelection = true;
    } else if (keyCode === this.keyCode.down) {
      this.model.moveIndexDown();
      doSelection = true;
    }

    if (doSelection) {
      this.$el.find('.suggest-result').removeClass('selected');
      this.$el
        .find('.suggest-result')
        .eq(this.model.get('suggestItemIndex'))
        .addClass('selected');
    }

    this.resizeSuggestContainer();
  },

  onSuggestClick: function(event) {
    this.model.set({
      searchPhrase: this.model.get('suggestions')[
        $(event.currentTarget).index()
      ].name,
      submittedByClick: true
    });
    this.$el.find('form').submit();
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/searchField/searchFieldView.js
 **/